<template>

    <b-overlay :show="showOverlay" rounded="sm">
        <template #overlay>
            <div class="text-center" style="margin-top: 35px;">
                <b-icon icon="three-dots" animation="cylon" font-scale="2"></b-icon>
            </div>
        </template>
        <div v-if="maengel">
          <b-form-select v-model="selected" :options="options" />
        </div>
    </b-overlay>

</template>

<script>

    import axios from 'axios';
    axios.defaults.withCredentials = true;

    // Define a new component
    export default {
        name: 'FindMangelOfCustomer',
        props: ['customer', 'value'],
        /*
          Defines the data used by the component
        */
        data: function () {
            return {
              selected: null,
              options: null,
              maengel: null
            }
        },
        computed: {

          showOverlay: function () {
            if (this.maengel == null) return true;
            return false;
          }

        },
        mounted: function () {

          this.init();

        },
        watch: {

          selected: function (newVal, oldVal) {
            if (newVal && oldVal && newVal.id != oldVal.id) {
              this.emitme();
            } else if (newVal) {
              this.emitme();
            } else if (newVal == null && oldVal) {
              this.selected = null;
            }
          },
          customer: function () {
            this.init();
          },
          value: function (newVal) {
            this.selected = newVal
          }

        },
        methods: {

          init: function () {

            this.maengel = null;
            if (this.customer) {

              console.log ('init find Mangel ...');
              this.options    = [
                { value: null, text: '--' }
              ];
              this.selected   = null;

              let that      = this;
              const url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getMaengel';
              var params   = {
                customer: JSON.stringify(this.customer)
              };

              axios ({
                method: 'GET',
                params: params,
                url: url
              }).then(response => {

                console.log('response getMaengel', response.data);
                that.maengel = response.data;
                if (that.maengel && that.maengel.length > 0) {
                  for (var i = 0; i < that.maengel.length; i++) {
                    let positionsNr = '';
                    if (that.maengel[i].positionsNr && that.maengel[i].positionsNr != null) {
                      positionsNr = that.maengel[i].positionsNr + + ' | ';
                    }
                    that.options.push({
                      value: that.maengel[i],
                      text: that.maengel[i].nummer + '. | ' + positionsNr + that.maengel[i].descriptionShort
                    });
                  }
                }

              });

            }

          },
          emitme: function () {
            this.$emit('input', this.selected);
          }

        }

    }

</script>
